import {  Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import Card from "../components/Card";
import { model, fblink } from '../config/config';
import database from '../config/firebase';
import { TablePagination } from "@mui/material";
var fbkey = "-"
var currentpage = 0;
var firstlast = "limitToLast";
var atvalue = "startAt";
var lastfbkey = "";
var firstfbkey = "";

function Trending() {
	
	console.log("Trending model "+model);
	
    const [content, setContent] = useState([]);
    const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(20);
	const [count, setCount] = useState(500);
	
    const fetchTrending = async () => {
		
		 
		const { data }  = await axios.get(`${fblink}/watchface/${model}.json?orderBy="$key"&${atvalue}="${fbkey}"&${firstlast}=21`);
				
		let arrayOfObjects = Object.keys(data).map(key => {
		let ar = data[key]
		ar.key = key
		return ar})
		
		lastfbkey = arrayOfObjects[20].key;
		firstfbkey = arrayOfObjects[0].key;
		
		arrayOfObjects.shift();
		
		arrayOfObjects.sort((a, b) => b.fileid - a.fileid);
		
        setContent(arrayOfObjects);
		setPage(currentpage);
		window.scroll(0, 0);
		
		localStorage.setItem("attempts", "0")
		console.log("fetchTrending model "+model);
    }
	 const fetchTotal = async () => {
		 
		
		var ref = database.ref(`watchface/${model}/`);
		ref.once("value")
		  .then(function(snapshot) {
			
			setCount(snapshot.numChildren());
		});
	 }
    useEffect(() => {
		fetchTrending();
    }, [page])
	
	useEffect(() => {
		fetchTotal();
    }, [])

	 const handleChangePage = (event, newPage) => {
		    if(currentpage < newPage){
				firstlast = "limitToLast";
				atvalue = "endAt"
				currentpage = newPage;
				fbkey = firstfbkey;
			}
			else
			{				
				firstlast = "limitToFirst";
				atvalue = "startAt"
				currentpage = newPage;
				fbkey = lastfbkey;
			}
		  
		setPage(newPage);
		window.scroll(0, 0);
	  };

	  const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 20));
		//setPage(0);
	  };
  
    return (
        <div className='container' style={{ padding: "64px 1vw 64px 1vw" }}>
            <Typography variant="h4" component="h4" mb={5}>
            Amazfit {model.toUpperCase()} latest watch faces
            </Typography>
            <div className="card-grid">
                {
                    content && content.map(item => {
                        return <Card key={item.fileid} {...item} />
                    })
                }
            </div>
            <TablePagination
			  component="div"
			  count={count}
			  page={page}
			  onPageChange={handleChangePage}
			  rowsPerPage={20}
			  rowsPerPageOptions={[20]}
			  onRowsPerPageChange={handleChangeRowsPerPage}
			/>
        </div>
    );
}
export default Trending;